import APIService from "@/services/APIService.js";

export const namespaced = true;

export const state = {
  activeGroups: {},
  userTracks: {},
  userProjects: {},
  mixTypes: {},
  username: "",
  jwt: "",
  userId: "",
  remainingTracks: 0,
  remainingRevisions: 0,
  remainingAtmosMix: 0,
  remainingStereoMix: 0,
  remainingMasteringMix: 0,
  fetchedTracks: 0,
  nameSortDirection: "",
  dateSortDirection: "",
  statusSortDirection: "",
};

export const mutations = {
  GET_ACTIVE_GROUPS(state, activeGroups) {
    state.activeGroups = activeGroups;
  },
  GET_TRACKS_BY_USER(state, userTracks) {
    state.userTracks = userTracks;
  },
  GET_PROJECTS_BY_USER(state, userProjects) {
    state.userProjects = Array.from(userProjects);
  },
  GET_MIXES_BY_CAT(state, mixTypes) {
    state.mixTypes = mixTypes;
  },
  REMOVE_FROM_ACTIVE_GROUP(state, element) {
    state.activeGroups.splice(
      state.activeGroups.findIndex((el) => el.groupname == element.element),
      1
    );
  },
  ADD_PROJECT_TO_LIST(state, { projectName, id }) {
    state.userProjects.push({ id, projectName });
  },
  BLANK_COMMIT(state) {
    state;
  },
  SET_USER_DETAILS(state, { username, jwt, userId }) {
    state.username = username;
    state.jwt = jwt;
    state.userId = userId;
  },
  CLEAR_USER_DETAILS(state) {
    state.username = "";
    state.jwt = "";
    state.userId = "";
    state.remainingTracks = 0;
    state.remainingRevisions = 0;
    state.fetchedTracks = 0;
    if (state.userProjects.length > 0) {
      state.userProjects.splice(0, state.userProjects.length);
    }
    if (state.userTracks.length > 0) {
      state.userTracks.splice(0, state.userTracks.length);
    }
    localStorage.removeItem("jwt");
    localStorage.removeItem("mxdUserName");
    localStorage.removeItem("userId");
  },
  SET_UP_REMAINING_TRACKS(state, response) {
    state.remainingTracks = response.response.data[0][0].mqty;
    state.remainingRevisions = response.response.data[0][0].rqty;
    state.remainingAtmosMix = response.response.data[0][0].aqty;
    state.remainingStereoMix = response.response.data[0][0].sqty;
    state.remainingMasteringMix = response.response.data[0][0].mstqty;
    state.fetchedTracks = 1;
  },
  SORT_BY_NAME(state) {
    state.statusSortDirection = "";
    state.dateSortDirection = "";
    if (state.nameSortDirection == "" || state.nameSortDirection == "up") {
      state.nameSortDirection = "down";
      state.userTracks.sort((a, b) =>
        a.trackname > b.trackname ? 1 : b.trackname > a.trackname ? -1 : 0
      );
    } else {
      state.nameSortDirection = "up";
      state.userTracks.sort((a, b) =>
        a.trackname < b.trackname ? 1 : b.trackname < a.trackname ? -1 : 0
      );
    }
  },
  SORT_BY_DATE(state) {
    state.statusSortDirection = "";
    state.nameSortDirection = "";
    if (state.dateSortDirection == "" || state.dateSortDirection == "up") {
      state.dateSortDirection = "down";
      state.userTracks.sort((a, b) =>
        a.timestamp > b.timestamp ? 1 : b.timestamp > a.timestamp ? -1 : 0
      );
    } else {
      state.dateSortDirection = "up";
      state.userTracks.sort((a, b) =>
        a.timestamp < b.timestamp ? 1 : b.timestamp < a.timestamp ? -1 : 0
      );
    }
  },
  SORT_BY_STATUS(state) {
    state.nameSortDirection = "";
    state.dateSortDirection = "";
    if (state.statusSortDirection == "" || state.statusSortDirection == "up") {
      state.statusSortDirection = "down";
      state.userTracks.sort((a, b) =>
        a.status > b.status ? 1 : b.status > a.status ? -1 : 0
      );
    } else {
      state.statusSortDirection = "up";
      state.userTracks.sort((a, b) =>
        a.status < b.status ? 1 : b.status < a.status ? -1 : 0
      );
    }
  },
  DECREMENT_TRACK_COUNTER(state) {
    if (state.remainingTracks > 0) {
      state.remainingTracks--;
    }
  },
  DECREMENT_ATMOS_COUNTER(state) {
    if (state.remainingAtmosMix > 0) {
      state.remainingAtmosMix--;
    }
  },
  DECREMENT_STEREO_COUNTER(state) {
    if (state.remainingStereoMix > 0) {
      state.remainingStereoMix--;
    }
  },
  DECREMENT_REVISION_COUNTER(state) {
    if (state.remainingRevisions > 0) {
      state.remainingRevisions--;
    }
  },
  DECREMENT_MASTERING_COUNTER(state) {
    if (state.remainingMasteringMix > 0) {
      state.remainingMasteringMix--;
    }
  },
};

export const non = {};
export const actions = {
  useTrackCredit({ commit }) {
    commit("DECREMENT_TRACK_COUNTER");
  },
  useAtmosCredit({ commit }) {
    commit("DECREMENT_ATMOS_COUNTER");
  },
  useStereoCredit({ commit }) {
    commit("DECREMENT_STEREO_COUNTER");
  },
  useRevisionCredit({ commit }) {
    commit("DECREMENT_REVISION_COUNTER");
  },
  useMasteringCredit({ commit }) {
    commit("DECREMENT_MASTERING_COUNTER");
  },
  fetchActiveGroups({ commit }, { isSimple, trackCategory }) {
    // APIService.getActiveGroups(isSimple, trackCategory)
    //   .then((response) => {
    //     commit("GET_ACTIVE_GROUPS", response.data);
    //   })
    //   .then(() => {
    //     APIService.getMixTypesByCategory(trackCategory).then((response) => {
    //       commit("GET_MIXES_BY_CAT", response.data);
    //     });
    //   });
  },
  fetchTracksByUserId({ commit }, { id }) {
    APIService.getTracksByUserId(id).then((response) => {
      response;
      commit("GET_TRACKS_BY_USER", response.data[0]);
    });
  },
  deleteTrackByTrackId({ commit }, { trackId, useremail }) {
    commit("BLANK_COMMIT");
    trackId;
    return APIService.deleteTrack(trackId, useremail).then((response) => {
      response;
    });
  },
  fetchProjectsByUserId({ commit }, { id }) {
    APIService.getProjectsByUserId(id).then((response) => {
      commit("GET_PROJECTS_BY_USER", response.data[0]);
    });
  },
  fetchMixTypeByCategory({ commit }, { cat }) {
    APIService.getMixTypesByCategory(cat).then((response) => {
      commit("GET_MIXES_BY_CAT", response.data[0]);
    });
  },
  removeFromActiveGroup({ commit }, { element }) {
    commit("REMOVE_FROM_ACTIVE_GROUP", { element });
  },

  createNewProject({ commit }, { userId, projectName }) {
    return APIService.postNewProject(userId, projectName).then((response) => {
      commit("ADD_PROJECT_TO_LIST", {
        projectName: projectName,
        id: response.data[0].id,
      });
    });
  },

  setNewMixElement(
    { commit },
    { trackId, elementGroup, elementUrl, elementName, isRef }
  ) {
    commit("BLANK_COMMIT");
    console.log(isRef);
    APIService.postNewMixElement(
      trackId,
      elementGroup,
      elementUrl,
      elementName,
      isRef
    );
  },
  sendUploadEmail({ commit }, { trackName, mixId, errors, user }) {
    commit("BLANK_COMMIT");
    APIService.postSendUploadCompleteEmail(trackName, mixId, errors, user);
  },
  updateMixes({ commit }, { mixId, trackId, status }) {
    commit("BLANK_COMMIT");
    APIService.postUpdateMixes(mixId, trackId, status);
  },
  getS3Sig({ commit }, { fileName, fileType, key, isRef }) {
    commit("BLANK_COMMIT");
    return APIService.getS3Signed(fileName, fileType, key, isRef);
  },
  updateApproveStatus({ commit }, { trackId, userId, useremail }) {
    return APIService.approveTrack(trackId, userId, useremail);
  },
  setUserDetails({ commit }) {
    if (state.fetchedTracks == 0) {
      APIService.getRemaningTracks(localStorage.getItem("userId")).then(
        (response) => {
          commit("SET_UP_REMAINING_TRACKS", { response });
          return commit("SET_USER_DETAILS", {
            username: localStorage.getItem("mxdUserName"),
            jwt: localStorage.getItem("jwt"),
            userId: localStorage.getItem("userId"),
          });
        }
      );
    } else {
      return commit("SET_USER_DETAILS", {
        username: localStorage.getItem("mxdUserName"),
        jwt: localStorage.getItem("jwt"),
        userId: localStorage.getItem("userId"),
      });
    }
  },
  login({ commit }, { username, password }) {
    return APIService.postLogin(username, password).then((response) => {
      commit("SET_USER_DETAILS", {
        username: response.data.user.username,
        jwt: response.data.token,
        userId: response.data.user.id,
      });

      localStorage.setItem("mxdUserName", response.data.user.username);
      localStorage.setItem("jwt", response.data.token);
      localStorage.setItem("userId", response.data.user.id);
      APIService.getRemaningTracks(localStorage.getItem("userId")).then(
        (response) => {
          commit("SET_UP_REMAINING_TRACKS", { response });
        }
      );
    });
  },
  logout({ commit }) {
    return commit("CLEAR_USER_DETAILS");
  },
  createAccount({ commit }, { username, jwt, userId }) {
    commit("SET_USER_DETAILS", {
      username,
      jwt,
      userId
    });
    localStorage.setItem("mxdUserName", username);
    localStorage.setItem("jwt", jwt);
    localStorage.setItem("userId", userId);
  },
  forgotPassword({ commit }, username) {
    commit("BLANK_COMMIT");
    return APIService.postForgotPassword(username);
  },
  resetPasswordCheck({ commit }, { token, username }) {
    commit("BLANK_COMMIT");
    return APIService.postResetPasswordCheck(token, username);
  },
  resetPasswordSubmit({ commit }, { username, password }) {
    commit("BLANK_COMMIT");
    return APIService.postResetPasswordFinal(username, password);
  },
  sortByName({ commit }) {
    commit("SORT_BY_NAME");
  },
  sortByDate({ commit }) {
    commit("SORT_BY_DATE");
  },
  sortByStatus({ commit }) {
    commit("SORT_BY_STATUS");
  },
};
